module.exports = __webpack_public_path__ + "img/file-2.25de260b.svg";